import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface CustomerSsoGuardProps {
  children: ReactNode;
}

/**
 * Redirects customers away from the login form when a magic-link token is present.
 * This allows the /customer/sso handshake to process before we render the portal layout.
 */
export function CustomerSsoGuard({ children }: CustomerSsoGuardProps) {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/customer/login') {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      const redirect = params.get('redirect');

      if (token) {
        const encoded =
          redirect && redirect.length > 0
            ? `&redirect=${encodeURIComponent(redirect)}`
            : '';
        window.location.replace(`/customer/sso?token=${encodeURIComponent(token)}${encoded}`);
      }
    }
  }, [location]);

  return <>{children}</>;
}
